export default __webpack_public_path__ + "static/media/27.c84bda56.jpg";